import React from "react";
import "../styles/SkipLink.css";

const SkipLink = () => {
  return (
    <a href="#main-content" className="skip-link">
      Skip to main content
    </a>
  );
};

export default SkipLink;

